import { put, select, takeLatest } from 'redux-saga/effects'
import { getRelationshipsAndGuarantors } from '../selectors/getRelationshipsAndGuarantors.selector'
import { setRelationshipsAndGuarantorsList } from '../store/relationshipsAndGuarantors.action'
import { RelationshipsAndGuarantorsConstants } from '../store/relationshipsAndGuarantors.constants'
import { IRelationshipsAndGuarantorsState } from '../store/relationshipsAndGuarantors.types'
export function* removeRelationshipsAndGuarantors() {
  const relationshipsAndGuarantors: IRelationshipsAndGuarantorsState = yield select(getRelationshipsAndGuarantors)
  const { relationshipsAndGuarantorsList, selectedRelationshipsAndGuarantorsKey } = relationshipsAndGuarantors

  if (selectedRelationshipsAndGuarantorsKey) {
    const updatedRelationshipsAndGuarantorsList = relationshipsAndGuarantorsList.filter(
      (data) => data.key !== selectedRelationshipsAndGuarantorsKey
    )
    yield put(setRelationshipsAndGuarantorsList(updatedRelationshipsAndGuarantorsList))
  }
}
export function* removeRelationshipsAndGuarantorsSaga() {
  yield takeLatest(
    [RelationshipsAndGuarantorsConstants.REMOVE_RELATIONSHIPS_AND_GUARANTORS],
    removeRelationshipsAndGuarantors
  )
}
